export const initialise = () => {
    const widgets = document.querySelectorAll<HTMLElement>('.attrax-list-pagination-widget')

    widgets.forEach((widget: HTMLElement) => {
        const list = widget.querySelector<HTMLElement>('.attrax-pagination__pagination')
        if (!list) return

        const items = list.querySelectorAll<HTMLLIElement>('.attrax-pagination__page-item')
        
        items.forEach((item: HTMLLIElement, index: number) => {
            if (item.classList.contains('attrax-pagination__page-item--current')) {
                items.forEach((otherItem: HTMLLIElement, otherIndex: number) => {
                    if (otherIndex < index - 2 || otherIndex > index + 2) {
                        otherItem.remove()
                    }
                })
            }
        })
    })
}